'use strict';

var _defineProperty = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/defineProperty");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _asyncGeneratorDelegate = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var debug = require('debug');

var ipfsUnixfsImporter = require('ipfs-unixfs-importer');

var dagPB = require('@ipld/dag-pb');

var stat = require('./stat.js');

var mkdir = require('./mkdir.js');

var addLink = require('./utils/add-link.js');

var mergeOpts = require('merge-options');

var createLock = require('./utils/create-lock.js');

var toAsyncIterator = require('./utils/to-async-iterator.js');

var toMfsPath = require('./utils/to-mfs-path.js');

var toPathComponents = require('./utils/to-path-components.js');

var toTrail = require('./utils/to-trail.js');

var updateTree = require('./utils/update-tree.js');

var updateMfsRoot = require('./utils/update-mfs-root.js');

var errCode = require('err-code');

var utils = require('../../utils.js');

var last = require('it-last');

var withTimeoutOption = require('ipfs-core-utils/with-timeout-option');

var ipfsUnixfs = require('ipfs-unixfs');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);

var mergeOpts__default = /*#__PURE__*/_interopDefaultLegacy(mergeOpts);

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

var last__default = /*#__PURE__*/_interopDefaultLegacy(last);

var mergeOptions = mergeOpts__default["default"].bind({
  ignoreUndefined: true
});
var log = debug__default["default"]('ipfs:mfs:write');
var defaultOptions = {
  offset: 0,
  length: Infinity,
  create: false,
  truncate: false,
  rawLeaves: false,
  reduceSingleLeafToSelf: false,
  cidVersion: 0,
  hashAlg: 'sha2-256',
  parents: false,
  progress: function progress(bytes, path) {},
  strategy: 'trickle',
  flush: true,
  leafType: 'raw',
  shardSplitThreshold: 1000
};

function createWrite(context) {
  function mfsWrite(_x4, _x5) {
    return _mfsWrite.apply(this, arguments);
  }

  function _mfsWrite() {
    _mfsWrite = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(path, content) {
      var opts,
          options,
          source,
          destination,
          parent,
          _args2 = arguments;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              opts = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
              options = mergeOptions(defaultOptions, opts);
              log('Reading source, destination and parent');
              _context2.next = 5;
              return createLock.createLock().readLock( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return toAsyncIterator.toAsyncIterator(content);

                      case 2:
                        source = _context.sent;
                        _context.next = 5;
                        return toMfsPath.toMfsPath(context, path, options);

                      case 5:
                        destination = _context.sent;
                        _context.next = 8;
                        return toMfsPath.toMfsPath(context, destination.mfsDirectory, options);

                      case 8:
                        parent = _context.sent;

                      case 9:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              })))();

            case 5:
              log('Read source, destination and parent');

              if (!(!options.parents && !parent.exists)) {
                _context2.next = 8;
                break;
              }

              throw errCode__default["default"](new Error('directory does not exist'), 'ERR_NO_EXIST');

            case 8:
              if (!(source == null)) {
                _context2.next = 10;
                break;
              }

              throw errCode__default["default"](new Error('could not create source'), 'ERR_NO_SOURCE');

            case 10:
              if (!(destination == null)) {
                _context2.next = 12;
                break;
              }

              throw errCode__default["default"](new Error('could not create destination'), 'ERR_NO_DESTINATION');

            case 12:
              if (!(!options.create && !destination.exists)) {
                _context2.next = 14;
                break;
              }

              throw errCode__default["default"](new Error('file does not exist'), 'ERR_NO_EXIST');

            case 14:
              if (!(destination.entryType !== 'file')) {
                _context2.next = 16;
                break;
              }

              throw errCode__default["default"](new Error('not a file'), 'ERR_NOT_A_FILE');

            case 16:
              return _context2.abrupt("return", updateOrImport(context, path, source, destination, options));

            case 17:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _mfsWrite.apply(this, arguments);
  }

  return withTimeoutOption.withTimeoutOption(mfsWrite);
}

var updateOrImport = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(context, path, source, destination, options) {
    var child;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return write(context, source, destination, options);

          case 2:
            child = _context4.sent;
            _context4.next = 5;
            return createLock.createLock().writeLock( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
              var pathComponents, fileName, parentExists, updatedPath, trail, parent, parentBlock, parentNode, result, newRootCid;
              return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      pathComponents = toPathComponents.toPathComponents(path);
                      fileName = pathComponents.pop();

                      if (!(fileName == null)) {
                        _context3.next = 4;
                        break;
                      }

                      throw errCode__default["default"](new Error('source does not exist'), 'ERR_NO_EXIST');

                    case 4:
                      parentExists = false;
                      _context3.prev = 5;
                      _context3.next = 8;
                      return stat.createStat(context)("/".concat(pathComponents.join('/')), options);

                    case 8:
                      parentExists = true;
                      _context3.next = 15;
                      break;

                    case 11:
                      _context3.prev = 11;
                      _context3.t0 = _context3["catch"](5);

                      if (!(_context3.t0.code !== 'ERR_NOT_FOUND')) {
                        _context3.next = 15;
                        break;
                      }

                      throw _context3.t0;

                    case 15:
                      if (parentExists) {
                        _context3.next = 18;
                        break;
                      }

                      _context3.next = 18;
                      return mkdir.createMkdir(context)("/".concat(pathComponents.join('/')), options);

                    case 18:
                      _context3.next = 20;
                      return toMfsPath.toMfsPath(context, path, options);

                    case 20:
                      updatedPath = _context3.sent;
                      _context3.next = 23;
                      return toTrail.toTrail(context, updatedPath.mfsDirectory);

                    case 23:
                      trail = _context3.sent;
                      parent = trail[trail.length - 1];

                      if (parent) {
                        _context3.next = 27;
                        break;
                      }

                      throw errCode__default["default"](new Error('directory does not exist'), 'ERR_NO_EXIST');

                    case 27:
                      if (!(!parent.type || !parent.type.includes('directory'))) {
                        _context3.next = 29;
                        break;
                      }

                      throw errCode__default["default"](new Error("cannot write to ".concat(parent.name, ": Not a directory")), 'ERR_NOT_A_DIRECTORY');

                    case 29:
                      _context3.next = 31;
                      return context.repo.blocks.get(parent.cid);

                    case 31:
                      parentBlock = _context3.sent;
                      parentNode = dagPB.decode(parentBlock);
                      _context3.next = 35;
                      return addLink.addLink(context, {
                        parent: parentNode,
                        name: fileName,
                        cid: child.cid,
                        size: child.size,
                        flush: options.flush,
                        shardSplitThreshold: options.shardSplitThreshold,
                        hashAlg: options.hashAlg,
                        cidVersion: options.cidVersion
                      });

                    case 35:
                      result = _context3.sent;
                      parent.cid = result.cid;
                      _context3.next = 39;
                      return updateTree.updateTree(context, trail, options);

                    case 39:
                      newRootCid = _context3.sent;
                      _context3.next = 42;
                      return updateMfsRoot.updateMfsRoot(context, newRootCid, options);

                    case 42:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _callee3, null, [[5, 11]]);
            })))();

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function updateOrImport(_x6, _x7, _x8, _x9, _x10) {
    return _ref5.apply(this, arguments);
  };
}();

var write = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(context, source, destination, options) {
    var sources, extra, content, mode, mtime, hasher, result;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (destination.exists) {
              log("Overwriting file ".concat(destination.cid, " offset ").concat(options.offset, " length ").concat(options.length));
            } else {
              log("Writing file offset ".concat(options.offset, " length ").concat(options.length));
            }

            sources = [];

            if (options.offset > 0) {
              if (destination.unixfs) {
                log("Writing first ".concat(options.offset, " bytes of original file"));
                sources.push(function () {
                  return destination.content({
                    offset: 0,
                    length: options.offset
                  });
                });

                if (destination.unixfs.fileSize() < options.offset) {
                  extra = options.offset - destination.unixfs.fileSize();
                  log("Writing zeros for extra ".concat(extra, " bytes"));
                  sources.push(asyncZeroes(extra));
                }
              } else {
                log("Writing zeros for first ".concat(options.offset, " bytes"));
                sources.push(asyncZeroes(options.offset));
              }
            }

            sources.push(limitAsyncStreamBytes(source, options.length));
            content = countBytesStreamed(catAsyncIterators(sources), function (bytesWritten) {
              if (destination.unixfs && !options.truncate) {
                var fileSize = destination.unixfs.fileSize();

                if (fileSize > bytesWritten) {
                  log("Writing last ".concat(fileSize - bytesWritten, " of ").concat(fileSize, " bytes from original file starting at offset ").concat(bytesWritten));
                  return destination.content({
                    offset: bytesWritten
                  });
                } else {
                  log('Not writing last bytes from original file');
                }
              }

              return _defineProperty({}, Symbol.asyncIterator, _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee5);
              })));
            });

            if (options.mode !== undefined && options.mode !== null) {
              mode = ipfsUnixfs.parseMode(options.mode);
            } else if (destination && destination.unixfs) {
              mode = destination.unixfs.mode;
            }

            if (options.mtime != null) {
              mtime = ipfsUnixfs.parseMtime(options.mtime);
            } else if (destination && destination.unixfs) {
              mtime = destination.unixfs.mtime;
            }

            _context6.next = 9;
            return context.hashers.getHasher(options.hashAlg);

          case 9:
            hasher = _context6.sent;
            _context6.next = 12;
            return last__default["default"](ipfsUnixfsImporter.importer([{
              content: content,
              mode: mode,
              mtime: mtime
            }], context.repo.blocks, {
              progress: options.progress,
              hasher: hasher,
              cidVersion: options.cidVersion,
              strategy: options.strategy,
              rawLeaves: options.rawLeaves,
              reduceSingleLeafToSelf: options.reduceSingleLeafToSelf,
              leafType: options.leafType
            }));

          case 12:
            result = _context6.sent;

            if (result) {
              _context6.next = 15;
              break;
            }

            throw errCode__default["default"](new Error("cannot write to ".concat(parent.name)), 'ERR_COULD_NOT_WRITE');

          case 15:
            log("Wrote ".concat(result.cid));
            return _context6.abrupt("return", {
              cid: result.cid,
              size: result.size
            });

          case 17:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function write(_x11, _x12, _x13, _x14) {
    return _ref7.apply(this, arguments);
  };
}();

var limitAsyncStreamBytes = function limitAsyncStreamBytes(stream, limit) {
  return /*#__PURE__*/function () {
    var _limitAsyncStreamBytes2 = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      var emitted, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, buf;

      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              emitted = 0;
              _iteratorAbruptCompletion = false;
              _didIteratorError = false;
              _context7.prev = 3;
              _iterator = _asyncIterator(stream);

            case 5:
              _context7.next = 7;
              return _awaitAsyncGenerator(_iterator.next());

            case 7:
              if (!(_iteratorAbruptCompletion = !(_step = _context7.sent).done)) {
                _context7.next = 19;
                break;
              }

              buf = _step.value;
              emitted += buf.length;

              if (!(emitted > limit)) {
                _context7.next = 14;
                break;
              }

              _context7.next = 13;
              return buf.slice(0, limit - emitted);

            case 13:
              return _context7.abrupt("return");

            case 14:
              _context7.next = 16;
              return buf;

            case 16:
              _iteratorAbruptCompletion = false;
              _context7.next = 5;
              break;

            case 19:
              _context7.next = 25;
              break;

            case 21:
              _context7.prev = 21;
              _context7.t0 = _context7["catch"](3);
              _didIteratorError = true;
              _iteratorError = _context7.t0;

            case 25:
              _context7.prev = 25;
              _context7.prev = 26;

              if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                _context7.next = 30;
                break;
              }

              _context7.next = 30;
              return _awaitAsyncGenerator(_iterator.return());

            case 30:
              _context7.prev = 30;

              if (!_didIteratorError) {
                _context7.next = 33;
                break;
              }

              throw _iteratorError;

            case 33:
              return _context7.finish(30);

            case 34:
              return _context7.finish(25);

            case 35:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[3, 21, 25, 35], [26,, 30, 34]]);
    }));

    function _limitAsyncStreamBytes() {
      return _limitAsyncStreamBytes2.apply(this, arguments);
    }

    return _limitAsyncStreamBytes;
  }();
};

var asyncZeroes = function asyncZeroes(count) {
  var chunkSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : utils.MFS_MAX_CHUNK_SIZE;
  var buf = new Uint8Array(chunkSize);

  function _asyncZeroes() {
    return _asyncZeroes2.apply(this, arguments);
  }

  function _asyncZeroes2() {
    _asyncZeroes2 = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              if (!true) {
                _context8.next = 5;
                break;
              }

              _context8.next = 3;
              return buf.slice();

            case 3:
              _context8.next = 0;
              break;

            case 5:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));
    return _asyncZeroes2.apply(this, arguments);
  }

  return limitAsyncStreamBytes(_asyncZeroes(), count);
};

var catAsyncIterators = /*#__PURE__*/function () {
  var _ref2 = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(sources) {
    var i;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            i = 0;

          case 1:
            if (!(i < sources.length)) {
              _context9.next = 6;
              break;
            }

            return _context9.delegateYield(_asyncGeneratorDelegate(_asyncIterator(sources[i]()), _awaitAsyncGenerator), "t0", 3);

          case 3:
            i++;
            _context9.next = 1;
            break;

          case 6:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));

  return function catAsyncIterators(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var countBytesStreamed = /*#__PURE__*/function () {
  var _ref3 = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(source, notify) {
    var wrote, _iteratorAbruptCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, buf, _iteratorAbruptCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _buf;

    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            wrote = 0;
            _iteratorAbruptCompletion2 = false;
            _didIteratorError2 = false;
            _context10.prev = 3;
            _iterator2 = _asyncIterator(source);

          case 5:
            _context10.next = 7;
            return _awaitAsyncGenerator(_iterator2.next());

          case 7:
            if (!(_iteratorAbruptCompletion2 = !(_step2 = _context10.sent).done)) {
              _context10.next = 15;
              break;
            }

            buf = _step2.value;
            wrote += buf.length;
            _context10.next = 12;
            return buf;

          case 12:
            _iteratorAbruptCompletion2 = false;
            _context10.next = 5;
            break;

          case 15:
            _context10.next = 21;
            break;

          case 17:
            _context10.prev = 17;
            _context10.t0 = _context10["catch"](3);
            _didIteratorError2 = true;
            _iteratorError2 = _context10.t0;

          case 21:
            _context10.prev = 21;
            _context10.prev = 22;

            if (!(_iteratorAbruptCompletion2 && _iterator2.return != null)) {
              _context10.next = 26;
              break;
            }

            _context10.next = 26;
            return _awaitAsyncGenerator(_iterator2.return());

          case 26:
            _context10.prev = 26;

            if (!_didIteratorError2) {
              _context10.next = 29;
              break;
            }

            throw _iteratorError2;

          case 29:
            return _context10.finish(26);

          case 30:
            return _context10.finish(21);

          case 31:
            _iteratorAbruptCompletion3 = false;
            _didIteratorError3 = false;
            _context10.prev = 33;
            _iterator3 = _asyncIterator(notify(wrote));

          case 35:
            _context10.next = 37;
            return _awaitAsyncGenerator(_iterator3.next());

          case 37:
            if (!(_iteratorAbruptCompletion3 = !(_step3 = _context10.sent).done)) {
              _context10.next = 45;
              break;
            }

            _buf = _step3.value;
            wrote += _buf.length;
            _context10.next = 42;
            return _buf;

          case 42:
            _iteratorAbruptCompletion3 = false;
            _context10.next = 35;
            break;

          case 45:
            _context10.next = 51;
            break;

          case 47:
            _context10.prev = 47;
            _context10.t1 = _context10["catch"](33);
            _didIteratorError3 = true;
            _iteratorError3 = _context10.t1;

          case 51:
            _context10.prev = 51;
            _context10.prev = 52;

            if (!(_iteratorAbruptCompletion3 && _iterator3.return != null)) {
              _context10.next = 56;
              break;
            }

            _context10.next = 56;
            return _awaitAsyncGenerator(_iterator3.return());

          case 56:
            _context10.prev = 56;

            if (!_didIteratorError3) {
              _context10.next = 59;
              break;
            }

            throw _iteratorError3;

          case 59:
            return _context10.finish(56);

          case 60:
            return _context10.finish(51);

          case 61:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[3, 17, 21, 31], [22,, 26, 30], [33, 47, 51, 61], [52,, 56, 60]]);
  }));

  return function countBytesStreamed(_x2, _x3) {
    return _ref3.apply(this, arguments);
  };
}();

exports.createWrite = createWrite;